window.opener.postMessage({
  type: "social-auth",
  data: {
    subscriptions: {
      search: true,
    },
  },
});
